module.exports = __webpack_public_path__ + "img/e204d35.png";